// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1 2.5H9.48063L11.4806 5H23V11.6379C21.7832 10.6157 20.2135 10 18.5 10C14.634 10 11.5 13.134 11.5 17C11.5 18.4872 11.9638 19.8662 12.7547 21H1V2.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M18.5 11.5C15.4624 11.5 13 13.9624 13 17C13 18.5184 13.6167 19.8948 14.6108 20.889C15.605 21.8832 16.9814 22.5 18.5 22.5C21.5376 22.5 24 20.0376 24 17C24 15.4816 23.3833 14.1052 22.3892 13.111C21.395 12.1168 20.0186 11.5 18.5 11.5ZM15 17C15 15.067 16.567 13.5 18.5 13.5C19.1032 13.5 19.6701 13.6521 20.1654 13.9206L15.4205 18.6652C15.152 18.17 15 17.6031 15 17ZM16.8346 20.0794L21.5795 15.3348C21.848 15.83 22 16.3969 22 17C22 18.933 20.433 20.5 18.5 20.5C17.8968 20.5 17.3299 20.3479 16.8346 20.0794Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-folder-blocked-filled')
export default class FolderBlockedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-blocked-filled',
    }
  }
}
